import React from "react";

const PrivacyPolicyPage = () => {
  return (
    <main className="container mx-auto px-4 py-8">
      <header className="mb-8">
        <h1 className="text-3xl font-bold">Политика конфиденциальности</h1>
      </header>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">1. Общие положения</h2>
        <p className="mb-4">
          Политика конфиденциальности интернет-магазина «Vanil» описывает порядок и условия обработки персональных данных пользователей, а также меры по их защите. Настоящая политика является неотъемлемой частью Правил пользования сайтом.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">2. Сбор информации</h2>
        <p className="mb-4">
          Мы собираем информацию, необходимую для оказания услуг, предоставления информации о продуктах и оформления заказов. Это включает:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>Контактные данные (телефон, e-mail);</li>
          <li>Персональные данные для доставки (ФИО, адрес);</li>
          <li>Историю заказов и предпочтения.</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">3. Использование и защита информации</h2>
        <p className="mb-4">
          Персональные данные используются для оформления заказов, информирования о новинках и акциях, а также для проведения маркетинговых исследований. Мы обеспечиваем защиту данных посредством современных методов шифрования, регулярных проверок и контроля доступа.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">4. Передача данных третьим лицам</h2>
        <p className="mb-4">
          Мы не передаем персональные данные пользователей третьим лицам без вашего согласия, за исключением случаев, предусмотренных законодательством РК или необходимых для исполнения обязательств (например, передача данных службам доставки).
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-4">5. Изменения в политике конфиденциальности</h2>
        <p className="mb-4">
          Мы оставляем за собой право вносить изменения в настоящую Политику конфиденциальности. Все изменения вступают в силу с момента их публикации на сайте.
        </p>
      </section>
    </main>
  );
};

export default PrivacyPolicyPage;
